<template>
    <div class="d-flex align-center" :style="{width:27*scores.length+'px'}">
      <v-spacer></v-spacer>
          <span class="mr-1">
            <svg height="30" width="23" v-for="(score, index) in scores" :key="index">
              <circle cx="10" cy="17" r="8"
                      :stroke="getFill(score)"
                      stroke-width="1.3"
                      :fill="getFill(score)" />
            </svg>
          </span>
    </div>
</template>

<script>
  export default {
    name: "BallsSummary",
    props: ['scores'],
    data() {
      return {
      }
    },
    computed: {
      colors() {
        let result_colors = this.$store.getters['app/colors']
        let colors = {
          1: result_colors['red'],
          2: result_colors['lred'],
          3: result_colors['yellow'],
          4: result_colors['yellow'],
          5: result_colors['green'],
          6: result_colors['green'],
          7: result_colors['yellow'],
          8: result_colors['yellow'],
          9: result_colors['lred'],
          10:result_colors['red'],
          fill: result_colors.fill
        }
        return colors
      },
    },
    methods: {
      getFill(score) {
        let numScore = Math.round(score)
        return this.colors[numScore]
      }
    }
  }
</script>